import React from 'react';

export const ProcessSection: React.FC = () => {
  const steps = [
    {
      number: '01',
      title: '申請配額與簽證',
      description: '我們代為處理外勞配額申請，協助準備文件並提交至相關部門，省時省力。',
      icon: 'ri-file-list-3-line',
      color: 'bg-blue-500'
    },
    {
      number: '02',
      title: '本地招聘支援',
      description: '根據規定，僱主需先進行本地招聘。我們提供專業協助，確保流程合規並盡力尋找合適本地人選。',
      icon: 'ri-search-line',
      color: 'bg-purple-500'
    },
    {
      number: '03',
      title: '精選外勞',
      description: '與內地14間官方指定勞務公司緊密合作，每天為您提供符合要求的外勞人選，供您挑選。',
      icon: 'ri-user-star-line',
      color: 'bg-green-500'
    },
    {
      number: '04',
      title: '全方位到港支援',
      description: '從醫療保障、舒適住宿到生活適應活動，我們提供全面支援，確保外勞順利融入香港環境。',
      icon: 'ri-heart-pulse-line',
      color: 'bg-red-500'
    }
  ];

  return (
    <section id="process" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            申請流程簡單明瞭
          </h2>
          <p className="text-xl text-gray-600">
            四個步驟，輕鬆完成外勞招聘
          </p>
        </div>

        <div className="relative">
          {/* Process line for desktop */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-1 bg-gray-200">
            <div className="h-full bg-gradient-to-r from-blue-500 via-purple-500 via-green-500 to-red-500 rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                {/* Step number circle */}
                <div className={`w-16 h-16 ${step.color} rounded-full flex items-center justify-center text-white font-bold text-xl mx-auto mb-6 relative z-10 shadow-lg`}>
                  {step.number}
                </div>
                
                {/* Content card */}
                <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
                  <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center mb-4 mx-auto">
                    <i className={`${step.icon} text-gray-600 text-xl`}></i>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-3 text-center">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm text-center">
                    {step.description}
                  </p>
                </div>

                {/* Arrow for mobile */}
                {index < steps.length - 1 && (
                  <div className="lg:hidden flex justify-center mt-6 mb-6">
                    <i className="ri-arrow-down-line text-gray-400 text-2xl"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-green-600 to-blue-600 text-white p-8 rounded-xl">
            <h3 className="text-2xl font-bold mb-4">
              萬業人才資本，您的信賴之選！
            </h3>
            <p className="text-lg mb-6">
              立即聯繫我們，體驗高效、專業的外勞招聘服務！
            </p>
            <div className="flex justify-center">
              <a 
                href="https://wa.me/85293663961"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-blue-600 px-8 py-3 rounded-lg hover:bg-gray-100 transition-colors duration-300 flex items-center whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                立即WhatsApp聯繫
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
